'use client';

import React, { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

export default function IncomeCalculatorSection() {
  const [bakul, setBakul] = useState(10);
  const [gosok, setGosok] = useState(50);

  const avgPricePerBakul = 30;
  const pricePerGosok = 2;
  const weeklyBakulIncome = bakul * avgPricePerBakul;
  const weeklyGosokIncome = gosok * pricePerGosok;
  const weeklyGross = weeklyBakulIncome + weeklyGosokIncome;
  const formattedGross = `RM${weeklyGross.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;

  return (
    <div className="bg-white/5 backdrop-blur-lg border border-white/10 rounded-[2.5rem] p-8 md:p-12 shadow-2xl">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
        <div className="space-y-12">
          <div className="space-y-6">
            <div className="flex justify-between items-center">
              <label className="text-lg font-heading font-bold text-white">
                Jumlah Bakul Lipat Seminggu
              </label>
              <span className="text-[#d4af37] font-heading font-black text-2xl">{bakul}</span>
            </div>
            <div className="relative">
              <input
                type="range"
                min={5}
                max={100}
                step={1}
                value={bakul}
                onChange={(e) => setBakul(parseInt(e.target.value))}
                className="w-full h-2 rounded-lg cursor-pointer"
                style={{ accentColor: '#d4af37', backgroundColor: 'rgba(255,255,255,0.08)' }}
              />
              <div className="flex justify-between mt-2 text-xs text-white/70 font-cta font-bold uppercase tracking-wider">
                <span>5 Bakul</span>
                <span>100 Bakul</span>
              </div>
            </div>
            <p className="text-xs text-white/60 italic">
              *Setiap bakul dianggarkan RM10 - RM30 pendapatan kepada anda.
            </p>
          </div>

          <div className="space-y-6">
            <div className="flex justify-between items-center">
              <label className="text-lg font-heading font-bold text-white">
                Jumlah Helai Gosok Seminggu
              </label>
              <span className="text-[#d4af37] font-heading font-black text-2xl">{gosok}</span>
            </div>
            <div className="relative">
              <input
                type="range"
                min={0}
                max={500}
                step={10}
                value={gosok}
                onChange={(e) => setGosok(parseInt(e.target.value))}
                className="w-full h-2 rounded-lg cursor-pointer"
                style={{ accentColor: '#d4af37', backgroundColor: 'rgba(255,255,255,0.08)' }}
              />
              <div className="flex justify-between mt-2 text-xs text-white/70 font-cta font-bold uppercase tracking-wider">
                <span>0 Helai</span>
                <span>500 Helai</span>
              </div>
            </div>
            <p className="text-xs text-white/60 italic">
              *Setiap helai dianggarkan RM2 pendapatan kepada anda.
            </p>
          </div>
        </div>

        <div
          className="rounded-3xl p-8 relative overflow-hidden flex flex-col justify-between h-full border border-[#d4af37]/30"
          style={{ backgroundColor: '#1a0f2e' }}
        >
          <div className="space-y-6">
            <div className="flex justify-between items-center pb-4 border-b border-white/10">
              <span className="text-white/70">Anggaran Pendapatan Kasar Mingguan</span>
              <span className="font-body font-bold text-white text-xl">{formattedGross}</span>
            </div>
          </div>
          <div className="mt-12 text-center">
            <p className="text-[#d4af37] text-sm font-cta font-bold uppercase tracking-widest mb-2">
              ANGGARAN PENDAPATAN ANDA
            </p>
            <p className="text-5xl md:text-6xl font-heading font-black bg-gradient-to-r from-[#bf953f] via-[#fcf6ba] to-[#aa771c] bg-clip-text text-transparent">
              {formattedGross}
            </p>
            <p className="text-xs text-white/60 mt-4 leading-relaxed">
              Hasil pengiraan ini adalah berdasarkan anggaran purata. Keuntungan sebenar bergantung
              kepada jumlah tempahan anda.
            </p>
          </div>
          <div className="mt-8">
            <a
              href="#register"
              className="flex items-center justify-center gap-2 w-full py-4 rounded-xl font-cta font-black hover:opacity-90 transition-all text-[#2d1b4e] bg-gradient-to-r from-[#bf953f] via-[#fcf6ba] to-[#aa771c]"
            >
              MULA JANA PENDAPATAN
              <Icon name="ArrowTrendingUpIcon" size={20} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
